export const AdminRoleId = 'c0eb868c-cb3c-42de-ba43-6a9f66f6b4e7';
